import { render, staticRenderFns } from "./FacebookToggleDialog.vue?vue&type=template&id=0bf84ab4&scoped=true&"
import script from "./FacebookToggleDialog.vue?vue&type=script&lang=js&"
export * from "./FacebookToggleDialog.vue?vue&type=script&lang=js&"
import style0 from "./FacebookToggleDialog.vue?vue&type=style&index=0&id=0bf84ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf84ab4",
  null
  
)

export default component.exports